<template>
  <div class="textlist" :class="objectClass">
    <slot />
  </div>
</template>

<script>
import "@smartdesign/core/css/elements/textlist.css";

export default {
  props: {
    /**
     * size `50`, `100`, `200`
     */
    size: {
      required: false,
      type: Number,
      default: 100,
      validator: (val) => {
        return [50, 100, 200].indexOf(val) !== -1;
      },
    },

    /**
     * if the list has icons (default `check`, can be overridden on each li element)
     */
    hasIcons: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    objectClass() {
      return {
        "textlist--50": this.size === 50,
        "textlist--200": this.size === 200,
        "textlist--icon": this.hasIcons,
      };
    },
  },
};
</script>
